import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { addDoc, collection } from 'firebase/firestore';
import { CommonModule } from '@angular/common';
import { FIRESTORE } from '../shared/firebase/firebase.tokens';
import { ToastService } from '../shared/toasts/toast.service';
import { SECTIONS } from '../shared/section';
import { CARDS } from '../shared/card';
import { ButtonComponent } from '../shared/button/button.component';
import { AccordionComponent } from '../shared/accordion/accordion.component';
import { RouterModule } from '@angular/router';
import { BUSINESS_INFO } from '../shared/data/business.data';

@Component({
  selector: 'lumiron-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SECTIONS,
    CARDS,
    ButtonComponent,
    AccordionComponent,
  ],
})
export class ContactComponent {
  private readonly firestore = inject(FIRESTORE);
  private readonly toastService = inject(ToastService);

  protected readonly business = BUSINESS_INFO;

  public readonly contactForm: FormGroup = new FormGroup({
    name: new FormControl(undefined, Validators.required),
    email: new FormControl(undefined, [Validators.required, Validators.email]),
    phone: new FormControl(undefined),
    subject: new FormControl(undefined, Validators.required),
    message: new FormControl(undefined, Validators.required),
  });

  protected readonly sendingMessage = signal(false);

  public sendContactForm(): void {
    if (!this.contactForm.valid) {
      return;
    }

    this.contactForm.disable();
    this.sendingMessage.set(true);

    addDoc(collection(this.firestore, 'contactForms'), {
      ...this.contactForm.value,
    })
      .catch(() => {
        this.sendingMessage.set(false);
        this.toastService.showToast('error', 'Es ist ein Fehler aufgetreten.');
        this.contactForm.enable();
      })
      .finally(() => {
        this.sendingMessage.set(false);
        this.toastService.showToast('success', 'Nachricht gesendet.');
        this.contactForm.reset();
        this.contactForm.enable();
      });
  }
}
